import { createContext, type PropsWithChildren, useCallback, useRef, useState } from 'react'
import type { PrintingContextValue, PrintingItem } from '../types/printing.type'

export const PrintingContextProvider = createContext<PrintingContextValue | undefined>(undefined)

export const PrintingProvider = ({ children }: PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState(false)
  const [currentItems, setCurrentItems] = useState<PrintingItem[]>([])
  const [error, setError] = useState<unknown>(null)
  const pendingCountRef = useRef(0)

  const startPrinting = useCallback((items: PrintingItem[]) => {
    pendingCountRef.current += 1
    setIsLoading(true)
    setCurrentItems(items)
  }, [])

  const finishPrinting = useCallback(() => {
    pendingCountRef.current = Math.max(0, pendingCountRef.current - 1)
    if (pendingCountRef.current === 0) {
      setIsLoading(false)
      setCurrentItems([])
    }
  }, [])

  const resetError = useCallback(() => {
    setError(null)
  }, [])

  return (
    <PrintingContextProvider.Provider
      value={{
        isLoading,
        currentItems,
        error,
        startPrinting,
        finishPrinting,
        setError,
        resetError,
      }}
    >
      {children}
    </PrintingContextProvider.Provider>
  )
}
